/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Context_Cat_6Inputs */

const en_mk_context_cat_6 = /** @type {(inputs: Mk_Context_Cat_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decisions`)
};

const id_mk_context_cat_6 = /** @type {(inputs: Mk_Context_Cat_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keputusan`)
};

/**
* | output |
* | --- |
* | "Decisions" |
*
* @param {Mk_Context_Cat_6Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_context_cat_6 = /** @type {((inputs?: Mk_Context_Cat_6Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Context_Cat_6Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_context_cat_6(inputs)
	return en_mk_context_cat_6(inputs)
});